/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit TysiaIconArrowBack/view.blocks to change it.
import React from 'react'
import styles from './view.module.css'



/** @type {import('Simple/types.js').View} */
export default function TysiaIconArrowBack({
  children,
  viewPath = "/DesignSystem/Svgs/TysiaIconArrowBack",
  alignSelf = "auto",
  marginTop = 0,
  marginBottom = 0,
  marginLeft = 0,
  marginRight = 0,
  opacity = 1,
  width = 24,
  height = 24,
  fill = "#353535",
  isAnimated,
  animation = "dash 5s linear forwards",
  strokeDashoffset = 1000,
  strokeDasharray = 1000
  
}) {
  return (<React.Fragment
>
<svg
  data-testid="TysiaIconArrowBack.Svg"
  data-view-path={viewPath}
 viewBox="0 0 24 24"
 style={{'--as-1-G6Yab': alignSelf,'--mt-2-G6Yab': typeof marginTop === 'number' ? `${marginTop}px` : marginTop,'--mb-3-G6Yab': typeof marginBottom === 'number' ? `${marginBottom}px` : marginBottom,'--ml-4-G6Yab': typeof marginLeft === 'number' ? `${marginLeft}px` : marginLeft,'--mr-5-G6Yab': typeof marginRight === 'number' ? `${marginRight}px` : marginRight,'--o-6-G6Yab': opacity,'--w-10-G6Yab': typeof width === 'number' ? `${width}px` : width,'--h-11-G6Yab': typeof height === 'number' ? `${height}px` : height,'--f-12-G6Yab': fill,'--a-7-G6Yab': isAnimated ? animation : "none",'--sd-8-G6Yab': isAnimated ? strokeDashoffset : 0,'--sd-9-G6Yab': isAnimated ? strokeDasharray : 0}}
 className={`views-block ${styles.Svg}`}
>
<path
  data-testid="TysiaIconArrowBack.SvgPath"
  data-view-path={viewPath}
 d="M17.51 3.87L15.73 2.1 5.84 12l9.9 9.9 1.77-1.77L9.38 12l8.13-8.13z"
 className="views-block"
/>
</svg>
{children}
</React.Fragment>)
}